import { LocaleCode } from '../helpers';
import { Internal } from '../internal';
import { ProfilesIncluded } from './vacancy.model';

/**
 * @deprecated Use `TSP.Helpers.BooleanResponse` instead. Kept only for the
 * consumers that already return it — do not use in new code.
 */
export interface BooleanResponse {
  readonly result: boolean;
}

export enum ComplicatedRequestTarget {
  COMPANIES = 'COMPANIES',
  CONTACTS = 'CONTACTS',
  CV = 'CV',
  EXPERIENCE = 'EXPERIENCE',
  EVERYWHERE = 'EVERYWHERE',
  LOCATION = 'LOCATION',
  MAIN_SKILL = 'MAIN_SKILL',
  NAME = 'NAME',
  PROJECTS = 'PROJECTS',
  RELATED_SKILLS = 'RELATED_SKILLS',
  TITLE = 'TITLE',
}
export interface ComplicatedRequestObject {
  skills?: string[];
  skillsExceptions?: string[];
  tags?: string[];
  tagsExceptions?: string[];
  keywords?: string[];
  keywordsExceptions?: string[];
  target: ComplicatedRequestTarget;
}
export interface DateRange {
  dateFrom: string | null;
  dateTo: string | null;
}
export interface DecodedProfileId {
  type: ProfileIdType;
  id: string;
}
/**
 * @deprecated Use `TSP.Helpers.EntitiesList` instead. Kept only for the
 * controllers that already return it — do not use in new code.
 */
export interface EntitiesList<T> {
  items: T[];
  included?: ProfilesIncluded;
  totalCount: number;
}
export enum ProfileIdType {
  PROFILE,
  PUBLIC_PROFILE,
  EXTERNAL,
}

export interface PaginationParams {
  pageNumber: number;
  pageSize: number;
}

export type ProfilesSearchParams = SearchParams & {
  candidateStage?: number[];
  complicatedRequest?: ComplicatedRequestObject[];
  countryId?: number | number[];
  ids?: number[] | string[];
  keywords?: string | string[];
};
export interface RequestWithToken {
  body: Record<string, unknown>;
  headers: Record<string, string>;
  i18nLang?: LocaleCode;
  params: Record<string, string>;
  query: Record<string, string>;
  method: string;
  originalUrl: string;
  socket: unknown;
  userToken?: UserTokenData;
  url: string;
}
export type SearchParamValue =
  | string
  | string[]
  | number
  | number[]
  | boolean
  | unknown;
export interface SearchParams {
  [key: string]: SearchParamValue | ComplicatedRequestObject[];
}
export interface SimpleItem {
  id: number | string;
  name: string;
}
export interface SortParams {
  sortField?: string;
  sortDirection?: string;
}
export const enum ProfilesSources {
  PROFILES = 'profiles',
  CANDIDATES = 'candidates',
}

export interface UserTokenData {
  access: Internal.Recruiter.Recruiter.Permissions;
  portalFeatures: Internal.Recruiter.Portal.Features;
  email: string;
  fullName: string;
  recruiterId: number;
  name: string;
  id: number;
  locale: LocaleCode;
  portalId: number;
  role: Internal.Recruiter.User.Role;
  recruiterSubordinateIds: number[];
}
interface BaseJwtPayload {
  iss?: string;
  sub?: string;
  aud?: string;
  exp?: number;
  nbf?: number;
  iat?: number;
  jti?: string;
}

export interface JwtTokenPayload
  extends
    Pick<
      UserTokenData,
      'email' | 'id' | 'locale' | 'name' | 'portalId' | 'recruiterId' | 'role'
    >,
    BaseJwtPayload {}
